import script from "./SideBarProfileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarProfileCard.vue?vue&type=script&setup=true&lang=js"

import "./SideBarProfileCard.vue?vue&type=style&index=0&id=7e467737&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e467737"]])

export default __exports__